/**
 * Normalizes style dimension abbreviation to a standard key.
 * Handles various formats from the database:
 * - "Medium", "MEDIUM", "M", "D" → "MEDIUM" (Regular width)
 * - "2E", "Wide", "WIDE", "W", "E" → "2E" (Wide)
 * - "B", "Narrow", "NARROW", "N", "2A" → "NARROW" (Narrow)
 *
 * Note: In standard footwear sizing, E/2E/4E are increasingly wide.
 * "B" represents narrow width.
 */
export function normalizeWidthAbbreviation(abbreviation) {
    const upper = abbreviation.toUpperCase();
    if (upper === 'MEDIUM' || upper === 'M' || upper === 'D')
        return 'MEDIUM';
    if (upper === '2E' || upper === 'WIDE' || upper === 'W' || upper === 'E')
        return '2E';
    if (upper === 'B' || upper === 'NARROW' || upper === 'N' || upper === '2A')
        return 'NARROW';
    return upper;
}
/**
 * Maps style dimension abbreviation to width label for display.
 */
export function getWidthLabel(abbreviation) {
    const normalized = normalizeWidthAbbreviation(abbreviation);
    const widthLabels = {
        MEDIUM: 'Regular width',
        '2E': 'Wide',
        NARROW: 'Narrow'
    };
    return widthLabels[normalized] ?? abbreviation;
}
/**
 * Maps style dimension abbreviation to icon config.
 */
export function getIconForWidth(abbreviation) {
    const normalized = normalizeWidthAbbreviation(abbreviation);
    const iconMap = {
        MEDIUM: { src: '/assets/IconNormalShoe.svg', alt: 'Normal' },
        '2E': { src: '/assets/IconWideShoe.svg', alt: 'Wide' },
        NARROW: { src: '/assets/IconNarrowShoe.svg', alt: 'Narrow' }
    };
    return (iconMap[normalized] ?? {
        src: '/assets/IconNormalShoe.svg',
        alt: abbreviation
    });
}
/**
 * Maps genderAgeDescription to row key.
 * Matches format used in genderVariations.id (e.g., "mens" → "men")
 */
const GENDER_AGE_TO_ROW = {
    mens: 'men',
    womens: 'women',
    unisex: 'unisex',
    kids: 'kids'
};
/**
 * Determines the gender category from model data.
 * Matches model's genderAgeDescription to genderVariations.id format.
 */
export function getGenderCategory(model) {
    const genderAge = model.genderAgeDescription?.toLowerCase() ?? '';
    return GENDER_AGE_TO_ROW[genderAge] ?? 'unisex';
}
